import { buttonClasses } from '@mui/material/Button';
import { createComponentOverrides } from '../theme/create-component-overrides';
export var createMuiButtonOverrides = createComponentOverrides(function (_a) {
    var _b, _c, _d;
    var mixins = _a.mixins, spacing = _a.spacing, typography = _a.typography, tokens = _a.tokens;
    return ({
        defaultProps: {
            size: 'large',
            disableElevation: true,
            disableRipple: true,
            disableFocusRipple: true,
            disableTouchRipple: true,
        },
        variants: [
            {
                props: { size: 'small' },
                style: {
                    minWidth: 'unset',
                    fontSize: typography.button.fontSize,
                },
            },
            {
                props: { size: 'large' },
                style: {
                    fontSize: typography.button.fontSize,
                },
            },
            {
                props: { variant: 'contained', size: 'small' },
                style: {
                    padding: spacing(0.5, 1.25),
                },
            },
            {
                props: { variant: 'contained', size: 'large' },
                style: {
                    padding: spacing(1.125, 2),
                },
            },
            {
                // this button is being depreated in the new brand. Using
                props: { variant: 'contained', color: 'default' },
                style: {
                    color: tokens.color_fg_on_button,
                    backgroundColor: tokens.color_bg_layer_alternate_bold,
                    '&:hover,&.Mui-hover': {
                        backgroundColor: tokens.color_bg_layer_bold,
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: tokens.color_bg_layer_bold,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'primary' },
                style: {
                    backgroundColor: tokens.color_bg_button_primary,
                    color: tokens.color_fg_on_button_primary,
                    '&:hover,&.Mui-hover': {
                        backgroundColor: tokens.color_bg_button_primary_hover,
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: tokens.color_bg_button_primary_pressed,
                    },
                },
            },
            {
                props: { variant: 'contained', color: 'danger' },
                style: {
                    backgroundColor: tokens.color_bg_button_danger,
                    color: tokens.color_fg_on_button_danger,
                    '&:hover,&.Mui-hover': {
                        color: tokens.color_fg_on_button_danger,
                        backgroundColor: tokens.color_bg_button_danger_hover,
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: tokens.color_bg_button_danger_pressed,
                    },
                },
            },
            {
                props: { variant: 'outlined' },
                style: {
                    padding: spacing(0.625, 1.375),
                    backgroundColor: tokens.color_bg_button,
                    borderColor: tokens.color_border_button,
                },
            },
            {
                props: { variant: 'outlined', size: 'small' },
                style: {
                    padding: spacing(0.375, 1.125),
                },
            },
            {
                props: { variant: 'outlined', size: 'large' },
                style: {
                    padding: spacing(1, 1.875),
                },
            },
            {
                props: { variant: 'outlined', color: 'default' },
                style: {
                    color: tokens.color_fg_on_button,
                    '&:hover,&.Mui-hover': {
                        backgroundColor: tokens.color_bg_button_hover,
                        borderColor: tokens.color_border_button,
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: tokens.color_bg_button_pressed,
                        borderColor: tokens.color_border_button,
                    },
                },
            },
            {
                props: { variant: 'outlined', color: 'primary' },
                style: {
                    color: tokens.color_fg_link_primary,
                    // This will be removed in the new brand. Using fg for border to match since new brand doesn't have this token.
                    borderColor: tokens.color_fg_link_primary,
                    '&:hover,&.Mui-hover': {
                        backgroundColor: tokens.color_bg_link_primary_hover,
                        borderColor: tokens.color_fg_link_primary,
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: tokens.color_bg_link_primary_pressed,
                        borderColor: tokens.color_fg_link_primary,
                    },
                },
            },
            {
                props: { variant: 'outlined', color: 'danger' },
                style: {
                    color: tokens.color_fg_link_danger,
                    borderColor: tokens.color_border_state_danger,
                    '&:hover,&.Mui-hover': {
                        color: tokens.color_fg_link_danger_hover,
                        backgroundColor: tokens.color_bg_link_danger_hover,
                        borderColor: tokens.color_border_state_danger,
                    },
                    '&:active,&.Mui-active': {
                        color: tokens.color_fg_link_danger_pressed,
                        backgroundColor: tokens.color_bg_link_danger_pressed,
                        borderColor: tokens.color_border_state_danger,
                    },
                },
            },
            {
                props: { variant: 'link' },
                style: {
                    backgroundColor: 'transparent',
                    color: tokens.color_fg_link,
                    padding: spacing(0.625, 1.5),
                },
            },
            {
                props: { variant: 'link', size: 'small' },
                style: {
                    padding: spacing(0.375, 1.25),
                },
            },
            {
                props: { variant: 'link', size: 'large' },
                style: {
                    padding: spacing(1, 2),
                },
            },
            {
                props: { variant: 'link', color: 'primary' },
                style: {
                    color: tokens.color_fg_link_primary,
                    '&:hover,&.Mui-hover': {
                        color: tokens.color_fg_link_primary_hover,
                        backgroundColor: tokens.color_bg_link_primary_hover,
                    },
                    '&:active,&.Mui-active': {
                        color: tokens.color_fg_link_primary_pressed,
                        backgroundColor: tokens.color_bg_link_primary_pressed,
                    },
                },
            },
            {
                props: { variant: 'link', color: 'default' },
                style: {
                    '&:hover,&.Mui-hover': {
                        backgroundColor: tokens.color_bg_link_hover,
                    },
                    '&:active,&.Mui-active': {
                        backgroundColor: tokens.color_bg_link_pressed,
                    },
                },
            },
            {
                props: { variant: 'link', color: 'danger' },
                style: {
                    color: tokens.color_fg_link_danger,
                    '&:hover,&.Mui-hover': {
                        color: tokens.color_fg_link_danger_hover,
                        backgroundColor: tokens.color_bg_link_danger_hover,
                    },
                    '&:active,&.Mui-active': {
                        color: tokens.color_fg_link_danger_pressed,
                        backgroundColor: tokens.color_bg_link_danger_pressed,
                    },
                },
            },
            {
                props: { color: 'danger' },
                style: (_b = {},
                    _b["&:focus,&.".concat(buttonClasses.focusVisible)] = mixins.focusRing({
                        color: tokens.color_border_focus_state_danger,
                    }),
                    _b),
            },
        ],
        styleOverrides: {
            root: (_c = {
                    padding: spacing(0.75, 1.5),
                    color: tokens.color_fg_link,
                    width: 'fit-content'
                },
                _c["&.".concat(buttonClasses.disabled, ", &:disabled")] = {
                    color: tokens.color_fg_on_button_disabled,
                    backgroundColor: tokens.color_bg_button_disabled,
                    borderColor: tokens.color_border_disabled,
                },
                _c),
            fullWidth: {
                width: '100%',
            },
            textSizeLarge: {
                padding: spacing(1, 2),
            },
            iconSizeLarge: {
                '& > *:first-child': {
                    fontSize: '1rem',
                    height: '1em',
                    width: '1em',
                },
            },
            iconSizeMedium: {
                '& > *:first-child': {
                    fontSize: '1rem',
                    height: '1em',
                    width: '1em',
                },
            },
            iconSizeSmall: {
                '& > *:first-child': {
                    fontSize: '1rem',
                    height: '1em',
                    width: '1em',
                },
            },
            disableElevation: (_d = {},
                _d["&:focus,&.".concat(buttonClasses.focusVisible)] = mixins.focusRing(),
                _d),
        },
    });
});
